module.exports = __webpack_public_path__ + "static/snowball-app-market-quotes_03-a7ef0fe0e09b012254db203f3d9015f9.gif";